<script setup lang="ts">
definePageMeta({
  layout: "focus",
});

const { site } = useSite();
const siteLogoSvg = useState<string | null>("site-logo-svg", () => null);
const siteLogo = useState<string | null>("site-logo", () => null);

const logoSrc = computed(() => siteLogoSvg.value || siteLogo.value);
const siteName = computed(() => {
  const name = site.value?.name;

  return typeof name === "string" && name.trim().length > 0
    ? name.trim()
    : "";
});
const logoAlt = computed(() =>
  siteName.value ? `${siteName.value} logo` : "Site logo"
);
</script>

<template>
  <Card
    class="w-full max-w-[460px] overflow-hidden border-border/70 bg-card/95 shadow-xl backdrop-blur"
  >
    <CardHeader class="items-center gap-5 text-center">
      <div
        v-if="logoSrc"
        class="flex max-h-24 max-w-64 items-center justify-center"
      >
        <img
          :src="logoSrc"
          :alt="logoAlt"
          class="max-h-20 max-w-full object-contain"
        />
      </div>

      <div class="space-y-2">
        <CardTitle class="text-2xl font-semibold tracking-tight sm:text-3xl">
          This site is currently unavailable
        </CardTitle>
        <CardDescription
          v-if="siteName"
          class="text-base font-medium text-foreground"
        >
          {{ siteName }}
        </CardDescription>
      </div>
    </CardHeader>

    <CardContent class="pb-8 text-center">
      <p class="text-sm leading-6 text-muted-foreground sm:text-base">
        This site has been disabled by an administrator. Please check back later
        or contact your administrator.
      </p>
    </CardContent>
  </Card>
</template>
